var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from 'react';
import { View, Image } from 'react-native';
import { component } from '../../Decorators/Component';
import { AnimatedTextView } from '../Typography/AnimatedTextView';
import { CoreConfig } from './../../../CoreConfig';
import { Configuration } from './../../../Domain/DTOs/Configuration/ConfigurationDTO';
let CardHeaderView = class CardHeaderView extends Component {
    render() {
        var _a, _b, _c, _d, _e, _f, _g;
        return (_jsxs(View, { style: (_a = this.props.style) === null || _a === void 0 ? void 0 : _a.container, children: [this.props.image
                    ? (_jsx(Image, { style: (_b = this.props.style) === null || _b === void 0 ? void 0 : _b.logo, source: {
                            uri: this.props.image
                        } }))
                    : (_jsx(View, { style: (_c = this.props.style) === null || _c === void 0 ? void 0 : _c.noImage, children: _jsx(AnimatedTextView, { textStyle: (_d = this.props.style) === null || _d === void 0 ? void 0 : _d.noImageText, children: "No image" }) })), _jsx(View, { style: (_e = this.props.style) === null || _e === void 0 ? void 0 : _e.overlay }), !!this.props.badge && (_jsx(View, { style: (_f = this.props.style) === null || _f === void 0 ? void 0 : _f.badge, children: _jsx(AnimatedTextView, { textStyle: (_g = this.props.style) === null || _g === void 0 ? void 0 : _g.text, children: this.props.badge }) }))] }));
    }
};
CardHeaderView = __decorate([
    component({
        provider: CoreConfig.provider,
        moduleName: CoreConfig.moduleName,
        componentName: Configuration.ComponentNames.cardHeader,
        style: {
            container: {
                position: 'relative'
            },
            badge: {
                position: 'absolute',
                top: 15,
                left: 15,
                backgroundColor: '#fff',
                paddingHorizontal: 6,
                paddingVertical: 1,
                borderRadius: 2
            },
            text: {
                fontSize: 9,
                lineHeight: 16,
                fontWeight: 'bold',
                textTransform: 'uppercase'
            },
            logo: {
                height: 110,
                resizeMode: 'cover',
                borderTopRightRadius: 8,
                borderTopLeftRadius: 8
            },
            noImage: {
                flex: 1,
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: 110,
                borderTopRightRadius: 8,
                borderTopLeftRadius: 8
            },
            noImageText: {
                fontSize: 20,
                lineHeight: 22,
                textTransform: 'uppercase'
            },
            overlay: {
                position: 'absolute',
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
                backgroundColor: '#000',
                opacity: 0.4,
                borderTopRightRadius: 8,
                borderTopLeftRadius: 8
            }
        }
    })
], CardHeaderView);
export { CardHeaderView };
